import { Ref } from '../types/api/BasicTypes';

interface RouteConfig {
  regex: RegExp,
  pathDirectoriesCount: number,
};

const routesToNotAddProductIdOnModal: Array<RegExp> = [
  new RegExp(/\/wishlists\/[0-9a-zA-Z]+/),
];

const routesToReplaceCollectionIdOnProductModal: Array<RegExp> = [
  new RegExp(/\/downloads\/[0-9a-zA-Z]/),
];

const routesToAddProductIdOnModal: Array<RouteConfig> = [
  {
    regex: new RegExp(/\/collections\/.+/),
    pathDirectoriesCount: 2,
  },
  {
    regex: new RegExp(/\/3d\/.+/),
    pathDirectoriesCount: 2,
  },
  {
    regex: new RegExp(/\/practice-footage\/.+/),
    pathDirectoriesCount: 2,
  },
];

export function handleAddProductIdToRoute(routerPath: string, productId: string): string {
  if (routesToNotAddProductIdOnModal.some((route: RegExp) => route.test(routerPath)))
    return;

  const pathDirectories: Array<string> = routerPath
    .split('?')[0]
    .split('/')
    .filter((component: string) => !!component);

  const lastIndex = pathDirectories.length - 1;

  if (routesToReplaceCollectionIdOnProductModal.some((route: RegExp) => route.test(routerPath))) {
    pathDirectories[lastIndex] = productId;
    return `/${pathDirectories.join('/')}`;
  }

  const routeData = routesToAddProductIdOnModal.find(
    (routeData: RouteConfig) => routeData.regex.test(routerPath)
  );
  if (!routeData) return routerPath;

  pathDirectories.length > routeData.pathDirectoriesCount ?
    pathDirectories[lastIndex] = productId :
    pathDirectories.push(productId);

  return `/${pathDirectories.join('/')}`;
}

export function handleRemoveProductIdFromRoute(routerPath: string, collection: Ref): string {
  if (routesToNotAddProductIdOnModal.some((route: RegExp) => route.test(routerPath)))
    return;

  const pathDirectories: Array<string> = routerPath
    .split('?')[0]
    .split('/')
    .filter((component: string) => !!component);
  const lastIndex = pathDirectories.length - 1;

  routesToReplaceCollectionIdOnProductModal.some((route: RegExp) => route.test(routerPath)) ?
    pathDirectories[lastIndex] = collection?.id.toString() :
    pathDirectories.splice(lastIndex);

  return `/${pathDirectories.join('/')}`;
}
